

export const CombinedPresentation = () => {
  const tours = ['AntiguaCity', 'AntiguaHobbitenango', 'AntiguaLago', 'AntiguaPacaya', 'ChichiPana',];
  return (
    <div className="combined-tour-presentation">
        {
            tours.map( (tour, i) => {
                return (<img src={`../assets/combinedTours/${tour}.jpg`} className={`combined-tour-presentation-img`} alt={tour} key={`${i}-One-Day-Tour-${tour}`} />);
            })
        }
    </div>
  )
}
